import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import MainItem from '@/views/Home.vue'

export const routes = [
  {
    path: '/',
    name: 'home',
    component: MainItem,
    meta: {
      title: 'Rádio Habblet • Um novo jeito de fazer fã-site!'
    }
  },
  {
    path: '/noticia/:id/:url',
    name: 'News',
    component: () => import('@/views/pageNews.vue'),
    props: true,
    meta: {
      title: 'Notícia • Rádio Habblet'
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/error.vue'),
    meta: {
      title: 'Erro • Rádio Habblet'
    }
  },
  {
    path: '/arte/:id/:url',
    name: 'Arte',
    component: () => import('@/views/pageArt.vue'),
    meta: {
      title: 'Arte • Rádio Habblet'
    }
  },
  {
    path: '/pagina/imager',
    name: 'imager',
    component: () => import('@/views/pageImager.vue'),
    props: true,
    meta: {
      title: 'Habblet Imager • Rádio Habblet'
    }
  },
  {
    path: '/pagina/equipe',
    name: 'equipe',
    component: () => import('@/views/pageTeam.vue'),
    meta: {
      title: 'Equipe • Rádio Habblet'
    }
  },
  {
    path: '/pagina/horarios',
    name: 'horarios',
    component: () => import('@/views/horarios.vue'),
    meta: {
      title: 'Horários • Rádio Habblet'
    }
  },
  {
    path: '/pagina/valores',
    name: 'valores',
    component: () => import('@/views/valores.vue'),
    meta: {
      title: 'Valores • Rádio Habblet'
    }
  },
  {
    path: '/pagina/ranking',
    name: 'Ranking',
    component: () => import('@/views/ranking.vue'),
    props: true,
    meta: {
      title: 'Ranking • Rádio Habblet'
    }
  },
  {
    path: '/pagina/recordes',
    name: 'recordes',
    component: () => import('@/views/records.vue'),
    meta: {
      title: 'Recordes • Rádio Habblet'
    }
  },
  {
    path: '/pagina/wireds',
    redirect: { name: 'wireds' }
  },
  {
    path: '/pagina/:id',
    name: 'pagina',
    component: () => import('@/views/pagina.vue'),
    props: true,
    meta: {
      title: 'Página • Rádio Habblet'
    }
  },

  {
    path: '/api',
    name: 'HabbletApi',
    component: () => import('@/views/pageApi.vue'),
    meta: {
      title: 'API Habblet • Rádio Habblet'
    }
  },
  {
    path: '/profile-api',
    name: 'ProfileApi',
    component: () => import('@/views/pageProfileApi.vue'),
    meta: {
      title: 'Perfil API • Rádio Habblet'
    }
  },
  {
    path: '/topico/:id/:url',
    name: 'TopicPage',
    props: true,
    component: () => import('@/views/pagetopic.vue'),
    meta: {
      title: 'Fórum • Rádio Habblet'
    }
  },
  {
    path: '/profile/:user?',
    name:
      'ProfilePage',
    props:
      true,
    component:
      () => import('@/views/pageProfile.vue'),
    meta: {
      title: 'Perfil • Rádio Habblet'
    }
  }
  ,
  {
    path: '/post-topic',
    name:
      'PostTopic',
    component:
      () => import('@/views/post-topic.vue'),
    meta: {
      title: 'Postar Tópico • Rádio Habblet'
    }
  }
  ,
  {
    path: '/wireds',
    name:
      'wireds',
    component:
      () => import('@/views/pageWired.vue'),
    meta: {
      title: 'Wireds • Rádio Habblet'
    }
  }
  ,
  {
    path: '/:pathMatch(.*)*',
    name:
      'NotFound',
    component:
      () => import('@/views/error.vue'),
    meta: {
      title: 'Página não encontrada • Rádio Habblet'
    }
  }

]

export function createAppRouter({ memory = false } = {}) {
  const history = memory
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL)

  return createRouter({
    history,
    routes,
    scrollBehavior(to) {
      if (typeof document === 'undefined') return
      let selectorToScroll = '#main'
      if (to.path === '/') {
        selectorToScroll = '#app'
      }
      setTimeout(() => {
        document.querySelector(selectorToScroll)?.scrollIntoView({ behavior: 'smooth' })
      }, 250)
    },
  })
}
